<template>
  <div class="trade-order-block">
    <div class="block-title">订单满意度评价</div>
    <!-- 销售 -->
    <div v-if="commentInfo.vendorScoreValue">
      <div class="block-title block-sub-title">销售满意度评价</div>
      <div class="block-content">
        <el-row class="content-row">
          <el-col :span="3">评价</el-col>
          <el-col :span="9">{{ commentInfo.vendorScoreValue }}</el-col>
          <el-col :span="3" v-if="commentInfo.salesComment">备注</el-col>
          <el-col :span="9" v-if="commentInfo.salesComment">{{ commentInfo.salesComment }}</el-col>
        </el-row>
      </div>
    </div>
    <!-- TM -->
    <div v-if="commentInfo.qualityScoreValue">
      <div class="block-title block-sub-title">TM满意度评价</div>
      <div class="block-content">
        <el-row class="content-row">
          <el-col :span="3">执行质量</el-col>
          <el-col :span="9">{{ commentInfo.qualityScoreValue }}</el-col>
          <el-col :span="3">执行速度</el-col>
          <el-col :span="9">{{ commentInfo.speedScoreValue }}</el-col>
        </el-row>
        <el-row class="content-row" v-if="commentInfo.tmComment">
          <el-col :span="3">备注</el-col>
          <el-col :span="21">{{ commentInfo.tmComment }}</el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'order-comment-info',
  data () {
    return {
      commentInfo: {
        qualityScoreValue: '',
        salesComment: '',
        speedScoreValue: '',
        tmComment: '',
        vendorScoreValue: ''
      }
    }
  },
  methods: {
    setCommentInfo (val) {
      this.commentInfo = val
    }
  }
}
</script>

<style lang="scss" scoped></style>
